module.exports = __webpack_public_path__ + "img/bg.c057d65b.png";